import script from "./VirtualCourtNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualCourtNew.vue?vue&type=script&setup=true&lang=js"

import "./VirtualCourtNew.vue?vue&type=style&index=0&id=fdf30d14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf30d14"]])

export default __exports__